<div style="text-align:center;padding-top:20px;" *ngIf="studentSpecialAttendance.length == 0 && isBusy==false"
  translate>No Special Additional Attendance data exists for student</div>
<div *ngIf="studentSpecialAttendance.length > 0 ">
  <div>
    <div *ngFor="let school of specialAdditionalAttendanceSchools">
      <div *ngIf="specialAdditionalAttendanceSchools.length == 1 && studentEnrollment.SchoolName != school.SiteName"><b
          style="font-size: 12pt;padding-bottom:5px;">{{school.SiteName}}</b></div>
      <div *ngIf="specialAdditionalAttendanceSchools.length > 1"><b style="font-size: 12pt;padding-bottom:5px;">{{school.SiteName}}</b></div>
      <mat-table matSort [dataSource]="getSpecialAttendanceDataSource(school.SiteId)" aria-label="Special Additional Data Table">
        <ng-container matColumnDef="Date">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 120px; max-width: 120px;"><span translate>Date</span>
            <filter class="mat-filter" [data]="specialAdditionalAttendanceAngularMatData" columnName="Date" dataType="date"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let att" style="min-width: 120px; max-width: 120px;">{{att.Date|date:'MM/dd/yy'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="MinutesAttended">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:110px;padding-right: 10px; justify-content: flex-end;">
              <span translate>Minutes<br/>Attended</span>
            <filter class="mat-filter" [data]="specialAdditionalAttendanceAngularMatData" columnName="MinutesAttended" dataType="number"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let att" style="min-width:100px;max-width:110px;padding-right: 30px; justify-content: flex-end;">{{att.MinutesAttended}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="MinutesPossible">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:110px;padding-right: 10px; justify-content: flex-end;">
              <span translate>Minutes<br/>Possible</span>
            <filter class="mat-filter" [data]="specialAdditionalAttendanceAngularMatData" columnName="MinutesPossible" dataType="number"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let att" style="min-width:100px;max-width:110px;padding-right: 30px; justify-content: flex-end;">{{att.MinutesPossible}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="ReasonCode">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:130px;max-width:130px;"><span translate>Reason Code</span>
            <filter class="mat-filter" [data]="specialAdditionalAttendanceAngularMatData" columnName="ReasonCode" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let att" style="min-width:130px;max-width:130px;padding-left: 30px;">{{att.ReasonCode}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Comment">
          <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Comment</span>
            <filter class="mat-filter" [data]="specialAdditionalAttendanceAngularMatData" columnName="Comment" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let att">{{att.Comment}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplaySpecialAdditional"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplaySpecialAdditional;" [attr.aria-label]="getSpecialAdditionalAriaRow(row)"></mat-row>
      </mat-table>
    </div>
  </div>
</div>